// Configuration object for header events
export const headerEventsConfig = {
    parentSelector: '.header',
    events: {
        logo: {
            selector: 'img.header__heading-logo.motion-reduce',
            event: {
                event: 'user_interaction',
                component: 'header',
                element: 'logo',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    link_url: element.href || '/'
                })
            }
        },
        contact: {
            selector: 'a.button.button--green',
            event: {
                event: 'user_interaction',
                component: 'header',
                element: 'cta_button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    click_text: element.textContent.trim(),
                    action_value: element.textContent.trim(),
                    link_url: element.href || '/pages/contact'
                })
            }
        },
        // Separate configuration for Language Selection
        languageSelect: {
            selector: '.localization-form .disclosure__list .disclosure__item a.link.link--text.disclosure__link.caption-large.focus-inset',
            event: {
                event: 'user_interaction',
                component: 'header',
                element: 'dropdown',
                field: 'language',
                action: 'select',
                trigger: 'focus',
                getDynamicData: (element) => {
                    const selectValue = element.getAttribute('data-value') || element.textContent.trim();
                    const dropdownButton = element.closest('.localization-form')?.querySelector('.disclosure__button span');
                    return {
                        action_value: selectValue
                    };
                }
            }
        },
        language: {
            selector: 'localization-form .disclosure__button',
            events: {
                open: {
                    event: 'user_interaction',
                    component: 'header',
                    element: 'dropdown',
                    field: 'language',
                    action: 'open',
                    trigger: 'focus',
                    getDynamicData: (element) => {
                        const button = element.closest('.disclosure__button');
                        if (!button) return null;
                        return {
                            current_language: button.querySelector('span')?.textContent.trim() || ''
                        };
                    }
                },
                close: {
                    event: 'user_interaction',
                    component: 'header',
                    element: 'dropdown',
                    field: 'language',
                    action: 'close',
                    trigger: 'blur',
                    getDynamicData: (element) => {
                        const button = element.closest('.disclosure__button');
                        if (!button) return null;
                        return {
                            current_language: button.querySelector('span')?.textContent.trim() || ''
                        };
                    }
                }
            }
        },
        login: {
            selector: 'svg.icon.icon-account',
            event: {
                event: 'user_interaction',
                component: 'header',
                element: 'icon',
                field: 'login',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    link_url: element.href || '/account/login'
                })
            }
        },
        emptyCart: {
            selector: 'svg.icon.icon-cart-empty',
            event: {
                event: 'user_interaction',
                component: 'header',
                element: 'icon',
                field: 'cart',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    link_url: element.href || '/cart'
                })
            }
        },
        cart: {
            selector: 'div.cart-count-bubble',
            event: {
                event: 'user_interaction',
                component: 'header',
                element: 'icon',
                field: 'cart',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    link_url: element.href || '/cart'
                })
            }
        }
    }
};